"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _menu = _interopRequireDefault(require("cccisd-icons/menu7"));
var _arrowLeft = _interopRequireDefault(require("cccisd-icons/arrow-left12"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right12"));
var _cccisdRenderInBody = _interopRequireDefault(require("cccisd-render-in-body"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var animationTime = Number(_style["default"].animationTime.replace('ms', ''));
var contentWidth = _style["default"].contentWidth;
var SideMenu = function SideMenu(_ref) {
  var renderCloseButton = _ref.renderCloseButton,
    renderTabs = _ref.renderTabs,
    slideInFrom = _ref.slideInFrom,
    tabs = _ref.tabs,
    trigger = _ref.trigger;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSliding = _useState2[0],
    setIsSliding = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isExpanded = _useState4[0],
    setIsExpanded = _useState4[1];
  (0, _react.useEffect)(function () {
    var reactApp = document.querySelector('#app').style;
    if (isExpanded) {
      reactApp.maxHeight = '100vh';
      reactApp.overflow = 'hidden';
      setIsSliding(true);
    } else {
      reactApp.maxHeight = 'initial';
      reactApp.overflow = 'auto';
    }
  }, [isExpanded]);
  (0, _react.useEffect)(function () {
    if (!isSliding) {
      setTimeout(function () {
        setIsExpanded(false);
      }, animationTime);
    }
  }, [isSliding]);
  function handleClickOutside(event) {
    if (event.target.isSameNode(event.currentTarget)) {
      setIsSliding(false);
    }
  }
  function closeNavigation() {
    setIsSliding(false);
  }
  function defaultRenderCloseButton() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].defaultCloseButton,
      style: {
        textAlign: slideInFrom
      }
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: "btn btn-default",
      onClick: closeNavigation,
      type: "button"
    }, slideInFrom === 'left' ? /*#__PURE__*/_react["default"].createElement(_arrowLeft["default"], null) : /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], null)));
  }
  function defaultRenderTabs() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].defaultTabs
    }, !Array.isArray(tabs) || tabs.length === 0 ? /*#__PURE__*/_react["default"].createElement("p", {
      className: _style["default"].noTabsMsg
    }, /*#__PURE__*/_react["default"].createElement("i", null, "No menu to show at this time.")) : /*#__PURE__*/_react["default"].createElement("ul", {
      className: "nav nav-pills nav-stacked"
    }, tabs.map(function (tab, i) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        role: "presentation",
        key: i,
        className: "".concat(tab.isActive ? 'active' : '', " ").concat(tab.isDisabled ? 'disabled' : '')
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "#",
        onClick: function onClick() {
          return !tab.isDisabled && tab.onClick({
            closeNavigation: closeNavigation
          });
        }
      }, tab.content));
    })));
  }
  function renderNavigation() {
    var slideInStyles = slideInFrom === 'left' ? {
      borderRadius: '0 5px 5px 0',
      left: 0
    } : {
      borderRadius: '5px 0 0 5px',
      right: 0
    };
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].menuContainer,
      style: {
        width: isExpanded ? '100vw' : '0vw',
        backgroundColor: isSliding ? 'rgba(0, 0, 0, 0.5)' : 'rgba(0, 0, 0, 0)'
      },
      onClick: handleClickOutside
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].menu,
      style: _objectSpread({
        width: isSliding ? contentWidth : '0px'
      }, slideInStyles)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].menuContent
    }, renderCloseButton ? renderCloseButton({
      closeNavigation: closeNavigation
    }) : defaultRenderCloseButton(), renderTabs ? renderTabs({
      tabs: tabs,
      closeNavigation: closeNavigation
    }) : defaultRenderTabs())));
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    onClick: function onClick() {
      return setIsExpanded(true);
    }
  }, trigger), /*#__PURE__*/_react["default"].createElement(_cccisdRenderInBody["default"], null, renderNavigation()));
};
SideMenu.propTypes = {
  renderCloseButton: _propTypes["default"].func,
  renderTabs: _propTypes["default"].func,
  slideInFrom: _propTypes["default"].oneOf(['left', 'right']),
  tabs: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    content: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
    isActive: _propTypes["default"].bool,
    isDisabled: _propTypes["default"].bool,
    onClick: _propTypes["default"].func
  })),
  trigger: _propTypes["default"].node
};
SideMenu.defaultProps = {
  renderCloseButton: null,
  renderTabs: null,
  slideInFrom: 'left',
  tabs: [],
  trigger: /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-default",
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(_menu["default"], null))
};
var _default = SideMenu;
exports["default"] = _default;